<template>
  <div
    v-loading="loading"
    class="user-brief"
  >
    <el-container class="common-container">
      <el-main class="main">
        <div class="form-title">
          <span>
            个人简介
          </span>
        </div>
        <div class="form">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            :rules="rules"
          >
            <el-form-item
              label="文字介绍"
              prop="text"
            >
              <mk-input
                v-model="form.text"
                type="textarea"
                resize="none"
                height="68"
                width="520"
                placeholder="输入文字介绍"
              ></mk-input>
            </el-form-item>
            <el-form-item
              label="语音介绍"
              prop="audio"
            >
              <el-upload
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="3"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button
                  size="small"
                  type="primary"
                >
                  点击上传
                </el-button>
                <div
                  slot="tip"
                  class="el-upload__tip"
                >
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <!-- <el-form-item
          label="家乡"
          prop="title"
        >
          <el-select
            v-model="value"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="value"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="value"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="教育"
          prop="title"
        >
          <el-date-picker
            v-model="form.title"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.title"
            resize="none"
            placeholder="输入毕业院校教育经历"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="标签"
          prop="title"
        >
          <div class="label-input">
            <div>
              <el-tag
                v-for="tag in dynamicTags"
                :key="tag"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
              >
                {{ tag }}
              </el-tag>
              <el-input
                v-if="tagInputVisible"
                ref="saveTagInput"
                v-model="tagInputValue"
                class="input-new-tag"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              >
              </el-input>
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput"
              >
                + 新增标签
              </el-button>
            </div>
            <span>最多显示6个标签，标签可隐藏不可修改</span>
          </div>
        </el-form-item> -->
          </el-form>
        </div>
      </el-main>
      <el-footer
        class="button-footer"
        height="56"
      >
        <el-button
          type="primary"
          size="small"
          @click="saveBasicInfo"
        >
          保存
        </el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'UserBrief',
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          text: '',
          audio: '',
          isActive: true
        }
      }
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 数据
      form: {
        text: '',
        audio: '',
        isActive: true
      },
      rules: {},
      imageUrl: '',
      // 语音介绍
      fileList: [],
      value: '',
      dynamicTags: [],
      tagInputVisible: false,
      tagInputValue: '',
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        }
      ],
      // 是否正在加载
      loading: false
    }
  },
  watch: {
    formData (newVal, oldVal) {
      this.form = this._.cloneDeep(newVal)
    }
  },
  methods: {
    // 保存信息
    saveBasicInfo () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          let res = await JINGTUIAPIS.CardApi.cardPut(
            {
              id: this.id
            },
            {
              introduction: this.form
            }
          )
          this.loading = false
          if (res.success) {
            this.$message.success('保存成功')
            this.form = res.data[0].introduction
          }
        } else {
          this.$message.error('有必填项未填写')
          return false
        }
      })
    },
    handlePreview () {},
    handleRemove () {},
    beforeRemove () {},
    handleExceed () {},
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    showInput () {
      this.tagInputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm () {
      let tagInputValue = this.tagInputValue
      if (tagInputValue) {
        this.dynamicTags.push(tagInputValue)
      }
      this.tagInputVisible = false
      this.tagInputValue = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.user-brief {
  background-color: #fff;
  width: 100%;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .form {
    margin-top: 30px;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .label-input {
    display: flex;
    flex-direction: column;
  }
}
</style>
